/**
 * Component Registry for Chesapeake Pointe
 * 
 * Inherits from @vibesites-aion-management/theme-belmont and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-aion-management/theme-belmont/registry';
import { FeeTransparency } from './components/FeeTransparency';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  FeeTransparency,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
